import React from 'react';

import {
    withStyles,
    ListSubheader,
    List,
} from '@material-ui/core';

import MHeader from './MHeader';
import theme from '../../services/theming';


class MBack extends React.Component {


    constructor(props) {
        super(props);
        const { title } = this.props;
        document.title = title
    }

    render() {
        const { classes, hideBack, hideNav, } = this.props;
        let backgroundColor = this.props.backgroundColor ? this.props.backgroundColor : theme.palette.background.paper;

        let appBarColor = this.props.appBarColor ? this.props.appBarColor : '#FFF'
        

        let showNav = true;
        if (hideNav == 1) {
            showNav = false
        }

        return (
            <React.Fragment>
                <div className={classes.root} style={{ backgroundColor: backgroundColor }} >
                    <List style={{ width: '100%', paddingTop: 0, paddingBottom: 0 }}>
                        {
                            showNav &&
                            <ListSubheader className={classes.subheader}>
                                {
                                    this.props.HeaderComponent ? this.props.HeaderComponent
                                        : <MHeader appBarColor={appBarColor} hideBack={hideBack} title={this.props.title} titlechildren={this.props.titlechildren} ></MHeader>
                                }
                            </ListSubheader>
                        }
                        {this.props.children}
                    </List>
                </div>
            </React.Fragment>
        );
    }
}

export default withStyles((theme) => ({
    root: {
        backgroundSize: 'cover',
        width: '100vw',
        minHeight: 'calc(100vh - 84px)',
        display: "flex",
        backgroundColor: theme.palette.background.paper,
        flexDirection: "column",
        alignItems: 'center',
    },
    subheader: {
        width: '100%',
        padding: theme.spacing(0, 0, 0, 0),
        backgroundColor: theme.palette.background.paper,
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
    },
}))(MBack);